const AirdropIcon = (props) => (
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Parachute canopy */}
    <path
      d="M32 4C17 4 6 16 6 30h52C58 16 47 4 32 4z"
      fill="transparent"
      stroke="currentColor"
    />

    {/* Canopy segments */}
    {/* <path d="M32 4v26" /> */}
    <path d="M20 8l12 22" />
    <path d="M44 8l-12 22" />
    {/* <path d="M12 18l20 12" /> */}
    {/* <path d="M52 18l-20 12" /> */}

    {/* Suspension lines */}
    <line x1="22" y1="34" x2="26" y2="44" />
    <line x1="42" y1="34" x2="38" y2="44" />
    <line x1="32" y1="30" x2="32" y2="44" />

    {/* Box */}
    <rect
      x="24"
      y="44"
      width="16"
      height="14"
      rx="2"
      fill="currentColor"
    />

    {/* Box details */}
    <path d="M32 44v14" stroke="currentColor" />
    <path d="M24 51h16" stroke="currentColor" />
  </svg>
);

// const AirdropIcon = (props) => (
//   <svg
//     viewBox="0 0 64 64"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}
//   >
//     {/* Parachute */}
//     <path
//       d="M32 2C17 2 4 14 2 29h60C60 14 47 2 32 2z"
//       fill="transparent"
//       stroke="currentColor"
//       strokeWidth="2"
//     />
//     <path
//       d="M32 2v27"
//       stroke="currentColor"
//       strokeWidth="2"
//     />
//     <path
//       d="M32 29L16 2M32 29L48 2"
//       stroke="currentColor"
//       strokeWidth="2"
//     />

//     {/* Strings */}
//     <path
//       d="M20 29l12 10 12-10"
//       stroke="currentColor"
//       strokeWidth="2"
//     />

//     {/* Box */}
//     <rect
//       x="20"
//       y="39"
//       width="24"
//       height="20"
//       rx="2"
//       fill="currentColor"
//       stroke="currentColor"
//       strokeWidth="2"
//     />
//     <path
//       d="M32 39v20"
//       stroke="currentColor"
//       strokeWidth="2"
//     />
//     <path
//       d="M20 49h24"
//       stroke="currentColor"
//       strokeWidth="2"
//     />
//   </svg>
// );

export default AirdropIcon;
